import React from "react";
import View from "../components/View";

import { Container, Card } from "react-bootstrap";
import { useNetworkName } from "../hooks/useNetwork";
import { DISTRIBUTORS } from "../utils/constants";
import ClaimDistributor from "../components/ClaimDistributor";
import { DistributorDetails } from "impermax-sdk";

/**
 * LendingPool page view.
 */
export default function Claim() {
  const network = useNetworkName();
  const distributors = DISTRIBUTORS[network];

  return (
    <View>
      <Container>
        <Card className="mt-5">
          {distributors.map((distributor: DistributorDetails, key: any) => (
            <ClaimDistributor distributor={distributor} key={key} />
          ))}
        </Card>
      </Container>
    </View>
  );
}
